import React from "react";
import { Button } from "@material-ui/core";
import { ButtonProps } from "@material-ui/core/Button";

interface Props<T> extends ButtonProps {
  onAwait: () => Promise<T>;
  onComplete?: (result: T) => void;
}

export default function AysncButton<T>({
  children,
  className,
  onAwait,
  onComplete,
  ...props
}: Props<T>) {
  const [disabled, setDisabled] = React.useState<boolean>(false);

  const onClick = React.useCallback(async () => {
    setDisabled(true);
    const result = await onAwait();
    setDisabled(false);
    onComplete && onComplete(result);
  }, [onAwait, onComplete]);

  return (
    <Button
      variant="contained"
      color="primary"
      {...props}
      onClick={onClick}
      className={className}
      disabled={disabled}
    >
      {children}
    </Button>
  );
}
